/**
 *
 * 路线交互 - 绘制百米桩
 *
 * 功能点:绘制百米桩
 * 场景:自由
 *
 */
import Vue from "@/main";
/**
 * 路网变量
 * @var graphicLayer - 路网图层
 */
export let graphicLayer;
/**
 * 初始化
 * 清空所有数据
 * @returns { any }
 */
export function init() {
  if (graphicLayer) {
    // 清除路径图层内所有矢量数据
    graphicLayer.clear();
    graphicLayer = null;
  }
}
/**
 * 初始化
 * 清空所有数据
 * @param  { Object } arr - 点集合
 * @returns { any }
 */
export function drawDots(arr) {
  // 判断路径图层是否存在
  console.log(arr);
  if (!graphicLayer) {
    graphicLayer = new mars3d.layer.GraphicLayer();
    Vue.$GLOBAL.map.addLayer(graphicLayer);
  } else {
    // 清除路径图层内所有矢量数据
    graphicLayer.clear();
  }
  Vue.$NProgress.set(0.8).inc(0.2);
  let rPColor = Vue.$GLOBAL.default_markIconColor;
  let iurl = "/img/marker/mark" + rPColor.slice(1) + ".png";
  let position, graphicDots;
  arr.forEach((item) => {
    position = item.position
      ? item.position
      : JSON.parse(item.bimVideoRoamingContent.contentValue);
    graphicDots = graphicLayer.addGraphic([
      {
        type: "billboard",
        position: new mars3d.LngLatPoint(position[0], position[1], position[2]),
        style: {
          image: iurl,
          scale: 1,
          scaleByDistance_farValue: 0.2,
          scaleByDistance_far: 100000,
          scaleByDistance_near: 100,
          scaleByDistance_nearValue: 0.5,
          scaleByDistance: true,
          label: {
            //不需要文字时，去掉label配置即可
            text: item.text.toString(),
            font_size: 16,
            font_family: "黑体",
            color: rPColor,
            outline: true,
            pixelOffsetY: -35,
            visibleDepth: false,
            distanceDisplayCondition: true,
            distanceDisplayCondition_far: 10000,
            distanceDisplayCondition_near: 0,
          },
          visibleDepth: false,
          horizontalOrigin: Cesium.HorizontalOrigin.CENTER, //可帮助定位图标相对焦点小方格的位置。
          verticalOrigin: Cesium.VerticalOrigin.BOTTOM, //可帮助定位图标相对焦点小方格的位置。
          //clampToGround: true, //贴地
        },
        flyTo: true,
      },
    ]);
    // graphicDotsArr.push(graphicDots);
    item.uid = graphicDots[0].uuid;
  });
  // 完成线的绘制 飞行
  if (graphicLayer != undefined) {
    if (graphicLayer) {
      graphicLayer.flyTo({
        complete: () => {
          Vue.$NProgress.done(true);
        },
      });
    }
  }
}
